import { grScope } from "@gr-common/head/logger";
const scope = grScope.scope("deprecated");
function deprecated(funcId, message = "") {
  const log = scope.scope(funcId);
  const dataObject = new Error(`${funcId}: ${message}`);
  const caller = `${dataObject.stack}`.split("\n")[2];
  log.warn(`${funcId} is deprecated, ${message}.`);
  otto.apm.sendCustomError("assets-legacy", dataObject, { caller });
}
function random() {
  return Math.random();
}
export {
  deprecated,
  random
};
